import { createFileRoute } from '@tanstack/react-router';
import { AmazonReviewSignalsPage } from '../../../pages/tools/market/AmazonReviewSignalsPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/amazon-review-signals')({
  head: () => toolHead('amazon-review-signals'),
  component: AmazonReviewSignalsPage,
});
